import _ from 'lodash'

export default {
  computed: {
    dragOffset() {
      return this.$store.state.dragOffset
    }
  },
  methods: {
    onDragStart(ev, item) {
      ev.dataTransfer.setData('drag_elm', JSON.stringify(item))
      this.$store.commit('drag_start', {
        offsetX: ev.offsetX,
        offsetY: ev.offsetY
      })
      return true
    },
    onDrop(ev) {
      let comp = null
      try {
        comp = JSON.parse(ev.dataTransfer.getData('drag_elm'))
      } catch (e) {
        return false
      }
      ev.dataTransfer.setData('drag_elm', null)
      const {offsetX, offsetY} = this.dragOffset
      const container = document.querySelector('#phone>.swiper-wrapper')
      const bbox = container.getBoundingClientRect()
      const category = comp.category
      delete comp.category
      let c = _.cloneDeep(comp)
      if (c.type === 'image') {
        const width = Math.min(c.position.w, (category === "10" ? 1 : 0.6) * this.site.width / this.site.rate / 100)
        const scale = width / c.position.w
        c.position.w = width
        c.position.h = scale * c.position.h
      }

      this.$store.commit('insert_component', {
        comp: c,
        x: ev.clientX - bbox.left - offsetX,
        y: ev.clientY - bbox.top - offsetY
      })
      this.$nextTick(() => {
        this.$store.commit('set_last_mask')
      })
    }
  }
}
